import { createSelector } from '@reduxjs/toolkit';

const selectStationsAndUnitsState = (store) => {
  return store.stationAndUnitsReducer;
};

export const selectStationsData = createSelector(
  selectStationsAndUnitsState,
  ({ stations, isStationsLoading }) => ({ stations, isStationsLoading })
);

export const selectAllUnitsData = createSelector(
  selectStationsAndUnitsState,
  ({ allUnits, isAllUnitsLoading }) => ({ 
    units: allUnits, 
    isUnitsLoading: isAllUnitsLoading 
  })
);

export const selectStationUnitsData = createSelector(
  selectStationsAndUnitsState,
  ({ stationUnits, isStationUnitsLoading, selectedStationForUnits }) => ({ 
    units: stationUnits, 
    isUnitsLoading: isStationUnitsLoading,
    selectedStationForUnits 
  })
);

export const selectStationsStatesData = createSelector(
  selectStationsAndUnitsState,
  ({ stationsStatesEnum, isStationsStatesEnumLoading }) => ({ 
    stationsStatesEnum, 
    isStationsStatesEnumLoading 
  })
);

export const selectUnitsTypesData = createSelector(
  selectStationsAndUnitsState,
  ({ unitsTypesEnum, isUnitsTypesEnumLoading }) => ({ 
    unitsTypesEnum, 
    isUnitsTypesEnumLoading 
  })
);
